import React, { createContext, useContext, useState, useEffect } from 'react';
import { ADMIN_CONFIG } from '../config/constants';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is already logged in
    const checkAuth = () => {
      const authData = localStorage.getItem('kogk_admin_auth');
      if (authData) {
        try {
          const { timestamp, isLoggedIn } = JSON.parse(authData);
          const now = new Date().getTime();

          // Check if session is still valid
          if (isLoggedIn && (now - timestamp) < ADMIN_CONFIG.sessionTimeout) {
            setIsAuthenticated(true);
          } else {
            // Session expired
            localStorage.removeItem('kogk_admin_auth');
            setIsAuthenticated(false);
          }
        } catch (error) {
          localStorage.removeItem('kogk_admin_auth');
          setIsAuthenticated(false);
        }
      }
      setLoading(false);
    };

    checkAuth();
  }, []);

  const login = (username, password) => {
    // Simple credential check (move to backend in production)
    if (username === ADMIN_CONFIG.username && password === ADMIN_CONFIG.password) {
      const authData = {
        isLoggedIn: true,
        timestamp: new Date().getTime(),
        username: username
      };

      localStorage.setItem('kogk_admin_auth', JSON.stringify(authData));
      setIsAuthenticated(true);
      return { success: true, message: 'Login successful!' };
    } else {
      return { success: false, message: 'Invalid username or password' };
    }
  };

  const logout = () => {
    localStorage.removeItem('kogk_admin_auth');
    setIsAuthenticated(false);
  };

  const value = {
    isAuthenticated,
    loading,
    login,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};